export const DECIMAL_RADIX = 10;
